import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import axios from "axios";
import { formatMoneda, validaMonto } from "../../../util/varios";
import { Input, Radio } from "../../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";

export const ConfiguracionModuloPP = (props) => {
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");

  const btnAcepta = useRef();
  const btnCancela = useRef();
  const radioAnual = useRef();
  const radioTrimestral = useRef();
  const radioMensual = useRef();
  const radioBs = useRef();
  const radioUnidad = useRef();
  const radioPetros = useRef();
  const radioSueldoMin = useRef();
  const radioUtMunicipal = useRef();
  const radioOtroFactor = useRef();
  const radioIntMoraFijo = useRef();
  const txtPorceInt = useRef();
  const radioIntMoraTasa = useRef();
  const txtPorceRecargo = useRef();
  const radioSi = useRef();
  const radioNo = useRef();
  const [select, setSelect] = useState("2");
  const [activate, setActivate] = useState(false);
  const [declawebs, setDeclawebs] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));
  const [operacion] = useState(2);
  const [values, setValues] = useState({
    periodopag: 0,
    periododeclaracio: 0,
    factorcalcul: 0,
    valorporcentua: 0,
    tipointere: 0,
    porcentajeintere: "0,00",
    porcentajerecarg: "0,00",
    mesesdecladef: "0,00",
    ptoimpr: 0,
    diavendeud: 0,
    factormult: 0,
    valormult: "0,00",
    diavendeudare: 0,
    declaracionwe: false,
    notifrit: false,
    diavendeuda1: 0,
    diavendeuda2: 0,
    mesdesdequincen: 0,
    porcenimpuest: "0,00",
  });

  const seleccionnarModulo = () => {
    let nomtab = "configpublicidad";

    let endpoint =
      op.conexion + `/api/comun/seleccionarmodulo?&nomtab=${nomtab}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setValues(response.data);
          if (response.data !== "") {
            if (response.data.tipointere === 1) {
              setSelect("1");
            } else {
              setSelect("2");
            }
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const seleccionarDeclaWeb = () => {
    let campos = "*";
    let nomtab = "configpublicidad";
    let orden = "1";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setDeclawebs(response.data[0].declaracionweb);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const crearMovimientoWeb = (operacion, nomtab, idtab) => {
    let endpoint = `${op.conexion}/api/comun/crearmovimientoweb/${operacion}`;
    let body;
    setActivate(true);

    body = {
      idmovi: null,
      nomtabla: nomtab,
      idtab: idtab,
      fecmovi: fechaSistema,
      riff: null,
      idcomer: idtab,
      idact: null,
      nanio: null,
      mess: null,
      tipdecla: null,
      numfac: null,
      prefac: null,
      operaper: null,
      actu: false,
      nmes: null,
      tip: null,
      peri: null,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/comun/actualizarmodulo`;
    let body;
    setActivate(true);

    body = {
      tipoconf: 4,
      periodo: radioAnual.current.checked
        ? 1
        : radioTrimestral.current.checked
        ? 2
        : 3,
      factor: radioBs.current.checked
        ? 1
        : radioUnidad.current.checked
        ? 2
        : radioPetros.current.checked
        ? 3
        : radioSueldoMin.current.checked
        ? 4
        : radioUtMunicipal.current.checked
        ? 5
        : 6,
      valor: null,
      decla: null,
      tipint: radioIntMoraFijo.current.checked ? 1 : 2,
      porint:
        select === "2"
          ? 0.0
          : txtPorceInt.current.value
              .trim()
              .replace(/\./g, "")
              .replace(",", "."),
      porrec: txtPorceRecargo.current.value
        .trim()
        .replace(/\./g, "")
        .replace(",", "."),
      meses: null,
      diaven: null,
      diavenreg: null,
      pto: null,
      factor1: null,
      valormul: null,
      declaweb: radioSi.current.checked ? true : false,
      diavenqui1: null,
      diavenqui2: null,
      cmbMes: null,
      descu: [],
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (declawebs === true) {
            crearMovimientoWeb(2, "configpublicidad", 0);
          }

          if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Creado Correctamente.",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });

    setActivate(true);
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (
      radioAnual.current.checked === false &&
      radioTrimestral.current.checked === false &&
      radioMensual.current.checked === false
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el Periodo de Pago",
        icono: "informacion",
      });

      sigue = false;
      radioAnual.current.focus();
    } else if (
      radioSi.current.checked === false &&
      radioNo.current.checked === false
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Defina si Declara Web",
        icono: "informacion",
      });
      sigue = false;
      radioSi.current.focus();
    } else if (
      radioBs.current.checked === false &&
      radioUnidad.current.checked === false &&
      radioPetros.current.checked === false &&
      radioSueldoMin.current.checked === false &&
      radioUtMunicipal.current.checked === false &&
      radioOtroFactor.current.checked === false
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione el Factor Calculo del Minimo Tributable",
        icono: "informacion",
      });

      sigue = false;
      radioBs.current.focus();
    } else if (
      radioIntMoraFijo.current.checked === false &&
      radioIntMoraTasa.current.checked === false
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione el Tipo de Interes por Mora Tributable",
        icono: "informacion",
      });

      sigue = false;
      radioIntMoraFijo.current.focus();
    } else if (
      radioIntMoraFijo.current.checked === true &&
      txtPorceInt.current.value === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Introduzca el Interes por Mora Fijo",
        icono: "informacion",
      });

      sigue = false;
      txtPorceInt.current.focus();
    } else if (txtPorceRecargo.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Introduzca el Recargo por Mora",
        icono: "informacion",
      });

      sigue = false;
      txtPorceRecargo.current.focus();
    } else if (sigue === true) {
      Actualizar(operacion);
    }
  };

  const blanquear = () => {
    setActivate(false);
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }

    // Devuelve el número formateado
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    return formatMoneda(e);
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });

    if (
      mensaje.texto == "Registro Creado Correctamente." ||
      mensaje.texto == "Registro Modificado Correctamente." ||
      mensaje.texto == "Registro Eliminado Correctamente."
    ) {
      props.setShow(false);
      seleccionnarModulo();
      seleccionarDeclaWeb();
    }
  };

  const cancelar = () => {
    blanquear();
    props.setShow(false);
  };

  const onChange = (event) => {
    if (event.target.name === "interesmora") {
      if (radioIntMoraFijo.current.checked) {
        setSelect("1");
      } else if (radioIntMoraTasa.current.checked) {
        setSelect("2");
      }
    }
  };

  useEffect(() => {
    seleccionnarModulo();
    seleccionarDeclaWeb();
  }, []);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {}}
    >
      <Modal.Header className="azulGradiant" style={{ height: "40px" }}>
        <h3 className="fw-bold m-0">
          Configuración Propaganda y Publicidad
        </h3>
        <a type = 'button'
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={cancelar}
        >
          Salir <i className="fas fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
        <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
            <legend className="float-none w-auto m-0">
                Periódo de Pagos
            </legend>
            <div className="col-auto m-0 p-0">
                <Radio label = "Anual"
                    ref={radioAnual}
                    defaultChecked={
                    values.periodopag === 1 ? true : false
                    }
                    name="periodopagos"
                    id="periodopagos1"
                />
            </div>
            <div className="col-auto m-0 p-0">
                <Radio label = "Trimestral"
                    ref={radioTrimestral}
                    defaultChecked={
                    values.periodopag === 2 ? true : false
                    }
                    name="periodopagos"
                    id="periodopagos2"
                />
            </div>
            <div className="col-auto m-0 p-0">
                <Radio label = "Mensual"
                    ref={radioMensual}
                    defaultChecked={
                    values.periodopag === 3 ? true : false
                    }
                    name="periodopagos"
                    id="periodopagos3"
                />
            </div>
        </fieldset>
        <fieldset className="col-5 m-0 ml-auto p-2 d-flex gap-2 border-azul rounded">
            <legend className="float-none w-auto m-0">
                Declaración en Linea (Internet)
            </legend>
            <div className="col-auto m-0 p-0">
                <Radio label = "Si"
                    ref={radioSi}
                    defaultChecked={
                    values.declaracionwe === true ? true : false
                    }
                    name="declaracionlinea"
                    value="0"
                    id="declaracionlinea1"
                />
            </div>
            <div className="col-auto m-0 p-0">
                <Radio label = "No"
                    ref={radioNo}
                    defaultChecked={
                    values.declaracionwe === false ? true : false
                    }
                    name="declaracionlinea"
                    value="1"
                    id="declaracionlinea2"
                />
            </div>
        </fieldset>
        <fieldset className="col-12 m-0 p-2 d-flex justify-content-between gap-2 border-azul rounded">
            <legend className="float-none w-auto m-0">
                Factor para el Cálculo del Minimo Tributable
            </legend>
            <div className="col-auto m-0 p-0">
                <Radio label = "Bolivares(Bs.)"
                    ref={radioBs}
                    defaultChecked={values.factorcalcul === 1 ? true : false}
                    name="minimotributable"
                    id="minimotributable1"
                />
            </div>
            <div className="col-auto m-0 p-0">
                <Radio label = "Unidades Tributarias"
                    ref={radioUnidad}
                    defaultChecked={values.factorcalcul === 2 ? true : false}
                    name="minimotributable"
                    id="minimotributable2"
                />
            </div>
            <div className="col-auto m-0 p-0">
                <Radio label = "Petros"
                    ref={radioPetros}
                    defaultChecked={values.factorcalcul === 3 ? true : false}
                    name="minimotributable"
                    id="minimotributable3"
                />
            </div>
            <div className="col-auto m-0 p-0">
                <Radio label = "Sueldo Minimo"
                    ref={radioSueldoMin}
                    defaultChecked={values.factorcalcul === 4 ? true : false}
                    name="minimotributable"
                    id="minimotributable4"
                />
            </div>
            <div className="col-auto m-0 p-0">
                <Radio label = "UT Municipal"
                    ref={radioUtMunicipal}
                    defaultChecked={values.factorcalcul === 5 ? true : false}
                    name="minimotributable"
                    id="minimotributable5"
                />
            </div>
            <div className="col-auto m-0 p-0">
                <Radio label = "Otros"
                    ref={radioOtroFactor}
                    defaultChecked={values.factorcalcul === 6 ? true : false}
                    name="minimotributable"
                    id="minimotributable6"
                />
            </div>
        </fieldset>

        <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
            <legend className="float-none w-auto m-0">
                Intereses por Mora
            </legend>
            <div className="col-4 m-0 p-0">
                <Radio label = "Fijo"
                    className="form-check-input my-auto"
                    ref={radioIntMoraFijo}
                    type="radio"
                    name="interesmora"
                    defaultChecked={
                    values.tipointere === 1 ? true : false
                    }
                    value="0"
                    id="interesmora1"
                    onChange={onChange}
                />
            </div>
            <div className="col-4 m-0 p-0">
                {select === "1" && 
                    <div className="col-12 m-0 p-0">
                        <Input
                            ref={txtPorceInt}
                            id="interes"
                            defaultValue={formatMoneda(
                                values.porcentajeintere
                                .toString()
                                .replace(".", ","),
                                ",",
                                ".",
                                2
                            )}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                        />
                    </div>
                }
            </div>
            <div className="col-4 m-0 p-0">
                <Radio label = "Según Tasa"
                    className="form-check-input my-auto"
                    ref={radioIntMoraTasa}
                    type="radio"
                    name="interesmora"
                    defaultChecked={
                    values.tipointere === 2 ? true : false
                    }
                    value="1"
                    id="interesmora2"
                    onChange={onChange}
                />
            </div>
        </fieldset>
        <fieldset className="col-5 m-0 ml-auto p-2 d-flex gap-2 border-azul rounded">
            <legend className="float-none w-auto m-0">
                Recargo por Mora
            </legend>
            <Input inputClassName="text-right"
                ref={txtPorceRecargo}
                id="recargo"
                defaultValue={formatMoneda(
                values.porcentajerecarg.toString().replace(".", ","),
                ",",
                ".",
                2
                )}
                onKeyUp={handleInputMontoChange}
                onBlur={handleInputMontoChange}
            />
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          ref={btnAcepta}
          onClick={onChangeValidar}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
